function getMonth(date: Date): string {
  return (date.getMonth() + 1).toString().padStart(2, '0');
}

function getDay(date: Date): string {
  return date.getDate().toString().padStart(2, '0');
}

export function dateToYYYYMMDD(date: Date): string {
  return `${date.getFullYear()}-${getMonth(date)}-${getDay(date)}`;
}

export function getCurrentDateYYYYMMDD(): string {
  return dateToYYYYMMDD(new Date());
}

export function getMonthName(value: number): string {
  return (window as any).languages['Months'][value];
}

export function getAbbreviatedMonthName(value: number): string {
  return (window as any).languages['MonthsAbbr'][value];
}

export function getDayName(value: number): string {
  return (window as any).languages['Days'][value];
}

export function getAbbreviatedDayName(value: number): string {
  return (window as any).languages['DaysAbbr'][value];
}

export function getOrdinalSuffix(i: number): string {
  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) {
    return 'st';
  }
  if (j === 2 && k !== 12) {
    return 'nd';
  }
  if (j === 3 && k !== 13) {
    return 'rd';
  }
  return 'th';
}

export function getOrdinalNumber(i: number): string {
  return `${i}${getOrdinalSuffix(i)}`;
}

export function formatDateForPuzzle(date: Date): string {
  const dayName = getDayName(date.getDay());
  const dayNumber = getOrdinalNumber(date.getDate());
  const month = getMonthName(date.getMonth());
  const year = date.getFullYear();
  return `${dayName} ${dayNumber} ${month} ${year}`;
}

interface DateElements {
  dayName: string;
  ordinalDayNumber: string;
  monthName: string;
  abbrivatedMonthName: string;
  year: number;
}

export function getDateElementsForPuzzle(date: Date): DateElements {
  return {
    dayName: getDayName(date.getDay()),
    ordinalDayNumber: getOrdinalNumber(date.getDate()),
    abbrivatedMonthName: getAbbreviatedMonthName(date.getMonth()),
    monthName: getMonthName(date.getMonth()),
    year: date.getFullYear(),
  };
}

export function formatTimeHMS(sec: number): string {
  return [sec >= 3600 ? Math.floor(sec / 3600) : null, Math.floor((sec % 3600) / 60), sec % 60]
    .filter((val) => val !== null)
    .map((val, index) => {
      const valStr = val!.toString();
      return index === 0 ? valStr.toString() : valStr.toString().padStart(2, '0');
    })
    .join(':');
}
